import { Component, Vue, Model, Prop, Watch } from 'vue-property-decorator';
import { ContractorFeedback } from '@/models/ContractorFeedback';
import CreateFeedbackDialog from '@/components/CreateFeedbackDialog/CreateFeedbackDialog.vue';
import { getFeedbackTypeColor } from '@/support/FeedbackType';
import { Contractor } from '@/models/Contractor';
import ErrorHandler from '@/support/ErrorHandler';
import { AxiosError } from 'axios';

@Component<FeedbackList>({
  components: {
    'create-feedback-dialog': CreateFeedbackDialog,
  },
})
export default class FeedbackList extends Vue {
  @Prop()
  protected contractorId!: string;

  @Prop()
  protected reportId!: string;

  @Prop({ default: 'contractor' })
  protected type!: 'report' | 'contractor';

  protected isLoadingMoreFeedback = false;

  protected isCreatingFeedback = false;

  protected isLoadingFeedback = true;

  protected types: Record<string, string> = {};

  protected feedbacks: ContractorFeedback[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected selectedTypes: any[] =[];

  protected async mounted(): Promise<void> {
    this.types = await this.fetchFeedbackTypes();
    await this.fetchFeedback();
    this.isLoadingFeedback = false;
  }

  protected async handleFeedbackCreated(): Promise<void> {
    this.isLoadingFeedback = true;
    await this.fetchFeedback();
    this.isLoadingFeedback = false;
  }

  protected getFeedbackTypeColor(type: string): string {
    return getFeedbackTypeColor(type);
  }

  protected async fetchFeedback(): Promise<void> {
    if (! this.contractorId && ! this.reportId) {
      return;
    }

    const filter: FeedbackFilter = {};

    if (this.contractorId) {
      filter.contractor = this.contractorId;
    }
    if (this.reportId) {
      filter.report = this.reportId;
    }

    if (this.selectedTypes && this.selectedTypes.length) {
      filter.types = this.selectedTypes;
    }

    await new ContractorFeedback()
      .include(['report', 'contractor'])
      .sort('created_at', 'DESC')
      .limit(20)
      .filter(filter)
      .all()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((response: any) => {
        this.feedbacks = response;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected async fetchFeedbackTypes(): Promise<any> {
    return new ContractorFeedback().listFeedbackTypes();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected get feedbackTypes(): any[] {
    const items = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(this.types)) {
      items.push({ text: value, value: key });
    }

    return items;
  }

  @Watch('selectedTypes', { deep: true })
  protected selectedTypesChanged(): void {
    this.feedbacks = [];
    this.handleFeedbackCreated();
  }
}

export interface FeedbackFilter {
  contractor?: string;
  report?: string;
  types?: string[];
  text?: string;
}
